import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";
import { formatDate } from "../lib/format";

export default function Settings() {
  const { activeCompany } = useAuth();
  const [members, setMembers] = useState([]);
  const [invites, setInvites] = useState([]);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member");
  const [error, setError] = useState("");
  const [inviteLink, setInviteLink] = useState("");

  const load = async () => {
    const [m, i] = await Promise.all([
      api.get("/companies/members").then((r) => r.data),
      api.get("/companies/invites").then((r) => r.data),
    ]);
    setMembers(m); setInvites(i);
  };
  useEffect(() => { load(); }, [activeCompany?.id]);

  const invite = async () => {
    setError(""); setInviteLink("");
    try {
      const { data } = await api.post("/companies/invites", { email, role });
      setInviteLink(data.invite_link);
      setEmail("");
      await load();
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
  };

  const remove = async (userId) => {
    if (!confirm("Remove this member?")) return;
    await api.delete(`/companies/members/${userId}`);
    await load();
  };

  return (
    <div data-testid="settings-page">
      <div className="mb-6">
        <div className="label-meta">Workspace</div>
        <div className="display">Team & settings</div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <div className="p-card col-span-2" data-testid="members-card">
          <h2 className="mb-3">Members</h2>
          <table className="p-table">
            <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Joined</th><th></th></tr></thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.id}>
                  <td className="font-medium">{m.full_name || "—"}</td>
                  <td className="text-[13px]">{m.email}</td>
                  <td><span className="status-pill" style={{ textTransform: "capitalize" }}>{m.role}</span></td>
                  <td className="text-[12px]">{m.joined_at ? formatDate(m.joined_at) : "—"}</td>
                  <td>{m.role !== "owner" && activeCompany?.role !== "member" && (
                    <button onClick={() => remove(m.id)} className="btn-ghost text-[12px]">Remove</button>
                  )}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="p-card" data-testid="invite-card">
          <h2 className="mb-3">Invite teammate</h2>
          <div className="space-y-3">
            <input type="email" className="p-input" placeholder="email@company.co.uk"
                   value={email} onChange={(e) => setEmail(e.target.value)} data-testid="invite-email-input" />
            <select className="p-input" value={role} onChange={(e) => setRole(e.target.value)} data-testid="invite-role-select">
              <option value="member">Member</option>
              <option value="admin">Admin</option>
            </select>
            <button onClick={invite} className="btn-primary w-full" disabled={!email} data-testid="invite-send-button">Send invite</button>
          </div>
          {error && <div className="text-[12px] mt-2">{error}</div>}
          {inviteLink && (
            <div className="mt-3 text-[12px] break-all border p-2 rounded" style={{ borderColor: "var(--parapet-border)" }}>
              <div className="font-medium mb-1">Invite link generated</div>
              <a href={inviteLink} className="underline">{inviteLink}</a>
            </div>
          )}

          {invites.length > 0 && (
            <>
              <div className="divider" />
              <h2 className="mb-2">Pending invites</h2>
              {invites.map((inv) => (
                <div key={`${inv.email}-${inv.role}`} className="text-[13px] py-1 border-b last:border-0 flex justify-between" style={{ borderColor: "var(--parapet-grid)" }}>
                  <span>{inv.email}</span>
                  <span className="status-pill">{inv.role}</span>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
